import React, { Fragment } from "react";
import { RightArrowIcon } from "../../../assets/icons";
import { ILiftOffHeader } from "../../../model/interface/subject";

interface LiftOffHeaderProps extends ILiftOffHeader {
  isSelected: boolean;
  isEnabled: boolean;
  index: number;
  handleHeaderChange: (header: ILiftOffHeader) => void;
}

const LiftOffHeader = (props: LiftOffHeaderProps) => {
  const handleHeaderChange = () => {
    props.handleHeaderChange(props);
  };
  return (
    <Fragment>
      <label
        className={`border p-4 flex items-center justify-between  focus:outline-none  border-indigo-200 z-10
         ${props.isSelected === true ? "bg-indigo-50" : ""}
         ${props.index === 0 ? "rounded-tl-md rounded-tr-md" : ""}         
         ${props.isEnabled === true ? "cursor-pointer" : "cursor-not-allowed"}`}
      >
        <div className="flex items-center">
          <input
            type="radio"
            x-model="value"
            name="header"
            value={props.liftOffHeaderId}
            className="h-5 w-5 mt-0.5 cursor-pointe border-green-800 focus:ring-green-800"
            disabled={!props.isEnabled}
            onChange={handleHeaderChange}
            checked={props.isSelected}
          />
          <div className="ml-3 flex flex-col">
            <span
              id="privacy-setting-0-label"
              className="block text-sm font-medium text-gray-900"
            >
              {props.header}
            </span>
          </div>
        </div>
        <span className="text-gray-800 hover:text-secondary-color">
          <RightArrowIcon />
        </span>
      </label>
    </Fragment>
  );
};

export default LiftOffHeader;
